// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__11u2K","detailsBorder":"styles_detailsBorder__1luGZ"};